import type { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

type MeshTagProps = {
  icon: LucideIcon;
  children: React.ReactNode;
  className?: string;
  as?: "li" | "span";
};

export default function MeshTag({
  icon: Icon,
  children,
  className,
  as: Tag = "li",
}: MeshTagProps) {
  return (
    <Tag
      className={cn(
        "service-mesh-surface flex items-center gap-2 overflow-hidden rounded-full border border-line/80 px-2.5 py-1.5",
        className,
      )}
    >
      <Icon
        className="size-3 shrink-0 text-foreground"
        strokeWidth={2.2}
        aria-hidden
      />
      <span className="text-[12px] font-medium leading-snug text-foreground">
        {children}
      </span>
    </Tag>
  );
}
